import {useState} from "react";
import useToast from "./useToast";

export const useFileReader = (initialData) => {
    const [fileData, setFileData] = useState(initialData ? initialData : []);
    const {showToast} = useToast()
    const validateSelectedFile = (file) => {
        const MAX_FILE_SIZE = 20480 // 20MB
        const fileSizeKiloBytes = file.size / 1024
        let errorMsg = ''
        if(fileSizeKiloBytes > MAX_FILE_SIZE){
          errorMsg = "Dosya 20mb'dan küçük olmalıdır ";
        }
        return errorMsg
      };
    const convert = files => {
        if (files) {
            let errorMessage = ''
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (validateSelectedFile(file) != '') {
                    errorMessage = validateSelectedFile(file)
                    break
                }
            }
            if (errorMessage == '') {
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setFileData(prev => ([...prev,{...prev,file:file,fileName:file.name,loading:true}]))
                    };
                    reader.readAsDataURL(file);
                }
            }else {
                showToast(errorMessage,'error')
            }
        }
    };
    return [fileData, setFileData, convert]
}